<template>
  <v-container class="modal-container" data-app>
    <v-dialog
      v-model="modalVisible"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>
            mdi-eye-plus
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="title"> How was it as at {{ restaurantName }} </v-card-title>
        <v-card-text>
          <v-form ref="form" class="form-visit">
            <v-text-field
              :rules="pickerRules"
              :label="visit.date.substr(0, visit.date.indexOf('T'))"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              disabled
            ></v-text-field>

            <v-text-field
              :rules="pickerRules"
              :label="visit.date.substr(visit.date.indexOf(':')+1,5)"
              prepend-icon="mdi-clock-time-four-outline"
              readonly
              disabled
            ></v-text-field>

            <v-rating
              class="ml-7"
              dense
              :value="visit.rating"
              half-increments
              background-color="orange lighten-3"
              color="orange"
              medium
              readonly
            ></v-rating>
            <v-textarea
              class="mt-6"
              :label="visit.comment"
              disabled
              :rules="textareaRules"
              prepend-icon="mdi-lead-pencil" ></v-textarea>
            <v-btn color="red" class="ma-2" @click="clearForm()">
              Cancel
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      right
      :multi-line="snackbarAtt"
      color="success"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          class="mr-3"
          icon
          color="black"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import user from "../../../services/user/user"

export default {
  name: "modal-visit",

  props: ["restaurantName", "modalVisible", "restaurantId", "visit"],

  data: () => ({
    form : {
      date : null,
      menuDate : false,
      time : null,
      menuTime : false,
      rating : 1,
      comment : "",
      menu2 : false,
    },
    snackbar : false,
    snackbarText : "",
    snackbarAtt : true,
    textareaRules: [
      v => v.length < 250 || "Comments have a limit of 250 Characters",
      v => !!v || "This field is required"
    ],
    pickerRules:[
      v => !!v || "This field is required"
    ]
  }),

  methods: {
    async submitForm() {
      if (this.$refs.form.validate()) {
        console.log(this.restaurantId)
        const token = {
          restaurant_id : this.restaurantId,
          comment : this.form.comment,
          rating : this.form.rating,
          date : `${this.form.date}T${this.form.time}Z`
        };
        console.log(token)
        try {
          await user.postUserVisit(token);
          this.clearForm();
          this.snackbar = true;
          this.snackbarText = "Visit Review added to restaurant";
          //alert("yeah");
        } catch (err) {
          this.snackbar = true;
          this.snackbarText = err
          //alert(err);
        }

      }
    },

    cancelForm() {
      this.clearForm()
    },

    clearForm() {
      this.modalVisible = false;
      this.form.comment = "";
      this.form.date = null;
      this.form.time = null;
      this.form.rating = 1;
    }

  }
}

</script>

<style scoped>

</style>
